export const FILTER_VALUE_SUBMIT = "FILTER_VALUE_SUBMIT";
export const ALL_FILTER_VALUE_SUBMIT = "ALL_FILTER_VALUE_SUBMIT";
